import { Colors } from '@/common/colors/colors';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import Input from '@/common/components/Input';
import Loading from '@/common/components/Loading';
import TextArea from '@/common/components/TextArea';
import Select from 'react-select';
import { emailSubjects } from './constants/emailSubjects';
import useConsultantEmail from './hooks/useConsultantEmail';
import {
	ButtonContainer,
	Container,
	Form,
	Header,
} from './styles/ConsultantEmailPage.styles';

const ConsultantEmailPage = () => {
	const hook = useConsultantEmail();

	return (
		<>
			{hook.isLoading && <Loading />}
			<Container>
				<Header className={`fade__in__animation`}>Send mail</Header>
				<Form className={`fade__in__animation`} onSubmit={hook.sendEmail}>
					<Select
						className={`fade__in__animation`}
						required
						value={hook.subject}
						onChange={hook.setSubject}
						options={emailSubjects}
						placeholder={'Select subject...'}
					/>
					<TextArea
						className={`fade__in__animation`}
						textAreaRef={hook.bodyRef}
						width='400px'
						placeholder='Type message body...'
						marginTop={0}
						rows={1}
					/>
					<Input
						className={`fade__in__animation`}
						id='base64'
						color={Colors.darkBlue}
						margin='0'
						type='file'
						showLabel={false}
						inputWidth={400}
						onChange={hook.handleFileChange}
						value={hook.selectedFile}
					/>
					<ButtonContainer className={`fade__in__animation`}>
						<SubmitButton type='submit' text='Send mail' />
					</ButtonContainer>
				</Form>
			</Container>
		</>
	);
};

export default ConsultantEmailPage;
